import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import { useMetaLeadsEventMutations } from "hooks/useMetaLeadsEventsTable";

const DeleteMetaLeadsEventModal = ({
  event,
  open,
  onOpenChange,
  onSuccess,
}) => {
  const { remove } = useMetaLeadsEventMutations();

  const handleConfirm = async () => {
    try {
      await remove.mutateAsync(event.id);
      onOpenChange(false);
      onSuccess?.();
    } catch {
      // remove surfaces the failure (e.g. the in-use guard) via toast; leave
      // the dialog open so the user can cancel or retry.
    }
  };

  return (
    <ConfirmDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete event?"
      description="Are you sure you want to delete this Meta Leads Event?"
      onConfirm={handleConfirm}
    />
  );
};

export default DeleteMetaLeadsEventModal;
